import { FieldProps } from "formik";
import * as React from "react";
import { ErrorComponent } from "src/design-system/Error";
import { StyledFormField } from "src/design-system/Form/Form";
import { FormTheme } from "src/design-system/Theme/form";
import { getObjectProperty } from "src/util/helpers";

export class WarningMessage extends React.Component<FieldProps> {
  public componentDidUpdate() {
    const { form, field } = this.props;
    const fieldValueFromFieldName = getObjectProperty(form.values, field.name);

    if (fieldValueFromFieldName === undefined) {
      form.setFieldValue(field.name, null);
    }
  }

  public render() {
    const { form, field } = this.props;
    const fieldTouched = getObjectProperty(form.touched, field.name);
    const fieldErrors = getObjectProperty(form.errors, field.name);

    return (
      <StyledFormField theme={FormTheme.Dark} noMargin={true}>
        {fieldTouched && fieldErrors && <ErrorComponent>{fieldErrors}</ErrorComponent>}
      </StyledFormField>
    );
  }
}
